import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "numAdults text-capitalize"
}
const _hoisted_2 = {
  key: 1,
  class: "text-capitalize"
}
const _hoisted_3 = {
  key: 2,
  class: "text-capitalize"
}
const _hoisted_4 = {
  key: 0,
  class: "numChildren text-capitalize"
}
const _hoisted_5 = {
  key: 1,
  class: "text-capitalize"
}
const _hoisted_6 = {
  key: 2,
  class: "text-capitalize"
}
const _hoisted_7 = {
  key: 1,
  class: "caption text-grey-700 d-flex align-items-center"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["height", "width"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["height", "width"]
const _hoisted_12 = { key: 2 }

import { computed, watch, ref } from 'vue'
import type { Ref } from 'vue'
import iconSizes from "@/config/iconSizes"
import { isServiceToDisplayDuration } from "@/vue/planning/logic/isServiceToDisplayDuration"
import { isCS } from "@/vue/planning/logic/cs"
// import getServiceDuration from "@/vue/planning/logic/getServiceDuration"
import store from '@/vue/planning/store/store'
import { isNlWebsite, isUkWebsite } from '@/config/trainPackageConfig'

// Props
interface Props {
	participants: number[]
	content: { [key: string]: string }
	excludedAges?: number[]
	optionName?: string | null
	variant?: { [key: string]: any } | null
	displayWithIcons?: boolean
	additionalClasses?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'participantsTotals',
  props: {
    participants: { default: () => [] },
    content: { default: () => ({}) },
    excludedAges: { default: () => [] },
    optionName: { default: '' },
    variant: { default: null },
    displayWithIcons: { type: Boolean, default: false },
    additionalClasses: { default: '' }
  },
  setup(__props: any) {

const props = __props

// Computed
const filteredParticipants = computed(() => {
	return props.participants.filter((age) => !props.excludedAges.includes(age))
})

const displayDuration = computed(() => {
	if (!props.optionName || props.optionName === 'transport') return ''
	return props.variant?.skipass
})

const numAdults = computed(() => {
	return filteredParticipants.value.filter((age) => age >= 18).length
})

const numChildren = computed(() => {
	return filteredParticipants.value.filter((age) => age < 18).length
})

const iconSize_adult = computed(() => iconSizes.l)
const iconSize_child = computed(() => iconSizes.s)

const showHomeAsNights = computed(() => isUkWebsite() || isNlWebsite())

return (_ctx: any,_cache: any) => {
  return (numAdults.value || numChildren.value)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["d-flex flex-row flex-wrap ml-2", _ctx.additionalClasses])
      }, [
        (!_ctx.displayWithIcons)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", null, [
                (numAdults.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(numAdults.value) + " ", 1))
                  : _createCommentVNode("", true),
                (numAdults.value === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.content.planner_resumeAdult), 1))
                  : _createCommentVNode("", true),
                (numAdults.value > 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.content.planner_resumeAdults), 1))
                  : _createCommentVNode("", true),
                (numAdults.value && numChildren.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _cache[0] || (_cache[0] = _createElementVNode("span", null, ",", -1)),
                      _cache[1] || (_cache[1] = _createTextVNode("   "))
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", null, [
                (numChildren.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(numChildren.value) + " ", 1))
                  : _createCommentVNode("", true),
                (numChildren.value === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.content.planner_resumeChild), 1))
                  : _createCommentVNode("", true),
                (numChildren.value > 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.content.planner_resumeChildren), 1))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, [
              (_ctx.optionName !== 'night' && !(_ctx.optionName === 'home' && showHomeAsNights.value))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[5] || (_cache[5] = _createTextVNode(_toDisplayString("(") + " ")),
                    (numAdults.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                          _createElementVNode("span", null, _toDisplayString(numAdults.value), 1),
                          (_openBlock(), _createElementBlock("svg", {
                            height: iconSize_adult.value,
                            width: iconSize_adult.value,
                            class: "icon",
                            style: {"margin-bottom":"2px"}
                          }, _cache[2] || (_cache[2] = [
                            _createElementVNode("use", { "xlink:href": "#___icon___person" }, null, -1)
                          ]), 8, _hoisted_9))
                        ]))
                      : _createCommentVNode("", true),
                    (numChildren.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _cache[4] || (_cache[4] = _createTextVNode(_toDisplayString("+") + " ")),
                          _createElementVNode("span", null, _toDisplayString(numChildren.value), 1),
                          (_openBlock(), _createElementBlock("svg", {
                            height: iconSize_child.value,
                            width: iconSize_child.value,
                            class: "icon"
                          }, _cache[3] || (_cache[3] = [
                            _createElementVNode("use", { "xlink:href": "#___icon___person" }, null, -1)
                          ]), 8, _hoisted_11))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.optionName !== 'transport' && _ctx.optionName !== 'flight' && _unref(isServiceToDisplayDuration)(_ctx.optionName || ''))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, " , " + _toDisplayString(props.variant?.skipass) + " " + _toDisplayString(_ctx.content.days), 1))
                      : _createCommentVNode("", true),
                    _cache[6] || (_cache[6] = _createTextVNode(" " + _toDisplayString(")")))
                  ], 64))
                : (_ctx.optionName === 'home' && showHomeAsNights.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(`(${Math.min(Number(props.variant?.skipass), 7) || ''} ${_ctx.content.planner_nights})`), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [], 64))
            ]))
      ], 2))
    : _createCommentVNode("", true)
}
}

})